import { Outlet } from "react-router";

import Footer from "../Footer";
import Header from "../Header";

import "./styles.scss";

export default function Layout() {
    return (
        <div className="min-vh-100 d-flex flex-column position-relative layout">
            <Header className="position-fixed w-100 top-0"></Header>
            <div className="flex-fill d-flex route-container">
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}
